module.exports = __webpack_public_path__ + "img/user-guide-02-05-01.737b4d15.png";